import React, { useContext, useEffect, useState } from 'react';

import { styled } from '@styles';
import * as S from './styles';
import { IProps } from './types';
import { Container, Table } from 'react-bootstrap';
import { getPrice } from '@utils';
import { PaymentChargeStatusEnum } from '__generated__/globalTypes';
import { maccaronDateForm } from '@src/core/utils';
import { DeviceContext, deviceType } from '@providers';
import AppleDownloadBadge from '@molecules/AppDownloadBanner/images/app_store_badge.png';
import GoogleDownloadBadge from '@molecules/AppDownloadBanner/images/google_play_badge.png';

import { APP_STORE_URL, PLAY_STORE_URL } from '@src/utils/constants';

const ButtonPadding = {
  paddingRight: '16px',
};

const BannerWrapper = styled.div`
  text-align: center;
  margin-bottom: 2rem;
`;

const OrderDetailSummary: React.FC<IProps> = ({ orderByToken }: IProps) => {
  const {
    status: orderStatus,
    fulfillments,
    statusDisplay,
    number,
    total,
    paymentType,
    paymentStatus,
    expectedArrivalDateInIndia,
  } = orderByToken;

  const [osType, setOsType] = useState('');
  const { isMobile } = useContext<deviceType>(DeviceContext);

  useEffect(() => {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('android') > -1) {
      setOsType('android');
    } else if (ua.indexOf('iphone') > -1) {
      setOsType('ios');
    } else {
      setOsType('none');
    }
  }, []);

  return (
    <S.Wrapper>
      {isMobile ? (
        <BannerWrapper>
          {osType == 'android' && (
            <a href={PLAY_STORE_URL} style={ButtonPadding} target="_blank">
              <img src={GoogleDownloadBadge} width="150px" />
            </a>
          )}
          {osType == 'ios' && (
            <a href={APP_STORE_URL} target="_blank">
              <img src={AppleDownloadBadge} width="150px" />
            </a>
          )}
        </BannerWrapper>
      ) : null}

      <S.OrderDetailCard style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.125)' }}>
        <S.OrderDetailHeader>
          <S.OrderDetail>Order Details</S.OrderDetail>
        </S.OrderDetailHeader>
        <S.OrderDetailBody>
          <Container>
            <Table borderless={true} size="sm">
              <tbody>
                <tr>
                  <S.Td>Order Number</S.Td>
                  <S.TableItemRight>#{number}</S.TableItemRight>
                </tr>
                <tr>
                  <S.Td>Payment Amount</S.Td>
                  <S.TableItemRight>{getPrice(total.gross.amount, true)}</S.TableItemRight>
                </tr>
                <tr>
                  <S.Td>Payment Method</S.Td>
                  <S.TableItemRight>{paymentType}</S.TableItemRight>
                </tr>
                {expectedArrivalDateInIndia && (
                  <tr>
                    <S.Td>Expected Arrival in India</S.Td>
                    <S.TableItemRight>{maccaronDateForm(expectedArrivalDateInIndia)}</S.TableItemRight>
                  </tr>
                )}
                {paymentStatus != PaymentChargeStatusEnum.NOT_CHARGED && (
                  <tr>
                    <S.Td>Order Status</S.Td>
                    <S.TableItemRight>{statusDisplay}</S.TableItemRight>
                  </tr>
                )}
              </tbody>
            </Table>
          </Container>
        </S.OrderDetailBody>
      </S.OrderDetailCard>
    </S.Wrapper>
  );
};

export { OrderDetailSummary };
